import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, Star } from 'lucide-react';
export function HeroSection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen pt-24 pb-12 px-4 overflow-hidden flex items-center bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-zinc-900 via-zinc-950 to-black" data-id="element-102">
      {/* Noise Texture Overlay */}
      <div className="absolute inset-0 bg-noise pointer-events-none opacity-20 mix-blend-overlay" data-id="element-103" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-104">
        {/* Left Column: Copy */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-start text-left" data-id="element-105">
          <span className="inline-block px-4 py-1.5 rounded-full bg-green-900/30 border border-green-500/30 text-green-400 text-xs sm:text-sm font-bold tracking-wider mb-6" data-id="element-106">
            NADIE TE ENSEÑÓ A PRODUCIR COMIDA EN CASA… CON UN SISTEMA REAL.
          </span>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6" data-id="element-107">
            Dejar tu huerta a medias no es falta de ganas.{' '}
            <br className="hidden lg:block" data-id="element-108" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-green-600" data-id="element-109">
              Es falta de un sistema que te guíe.
            </span>
          </h1>

          <p className="text-lg sm:text-xl text-zinc-400 mb-8 max-w-xl leading-relaxed" data-id="element-110">
            Descubre el método paso a paso para cultivar alimentos frescos en
            cualquier espacio, sin depender de la suerte ni perder tiempo en
            pruebas fallidas.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-111">
            <Button size="xl" onClick={scrollToCheckout} className="w-full sm:w-auto group" data-id="element-112">
              QUIERO EMPEZAR HOY
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-113" />
            </Button>
          </div>

          {/* Social Proof */}
          <div className="flex items-center gap-4" data-id="element-114">
            <div className="flex -space-x-3" data-id="element-115">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-10 h-10 rounded-full border-2 border-black bg-zinc-800 overflow-hidden" data-id="element-116">
                  <img src={`https://randomuser.me/api/portraits/thumb/men/${i + 20}.jpg`} alt="User" className="w-full h-full object-cover" data-id="element-117" />
                </div>)}
            </div>
            <div className="flex flex-col" data-id="element-118">
              <div className="flex text-yellow-500 mb-0.5" data-id="element-119">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-120" />)}
              </div>
              <span className="text-sm text-zinc-400 font-medium" data-id="element-121">
                <strong className="text-white" data-id="element-122">+800</strong> huertas activas en
                Latinoamérica
              </span>
            </div>
          </div>
        </motion.div>

        {/* Right Column: Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        rotate: 5
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative flex justify-center lg:justify-end" data-id="element-123">
          <div className="relative w-full max-w-md aspect-[4/5] group" data-id="element-124">
            {/* Glow Effect */}
            <div className="absolute inset-0 bg-green-500/20 blur-[100px] rounded-full group-hover:bg-green-500/30 transition-all duration-500" data-id="element-125" />

            <motion.img whileHover={{
            rotate: -2,
            scale: 1.05
          }} transition={{
            type: 'spring',
            stiffness: 300
          }} src="https://cdn.magicpatterns.com/uploads/1T83YRh2zHMBAWZqHaKiSV/ChatGPT_Image_24_feb_2026,_15_07_28.png" alt="Huerta Productiva 360 Manual" className="relative z-10 w-full h-full object-contain drop-shadow-2xl" data-id="element-126" />
          </div>
        </motion.div>
      </div>
    </section>;
}